module.exports = __webpack_public_path__ + "static/media/movies.e32e03cb.png";